export type StrideCategory = 'S' | 'T' | 'R' | 'I' | 'D' | 'E';
export type StrideStatus = 'open' | 'partial' | 'mitigated' | 'accepted' | 'na';

export interface StrideThreat {
  id: number;
  project_id: number;
  external_id?: string | null;
  stride_category: StrideCategory;
  threat: string;
  entity_name: string;
  entity_id?: number | null;
  entity_type?: string | null;
  boundary?: string | null;
  finding_ref?: string | null;
  mitigation?: string | null;
  status: StrideStatus;
  asrg_ids?: string | null;
  source: string;
  created_by: string;
}

export const STRIDE_LABELS: Record<StrideCategory, string> = {
  S: 'Spoofing',
  T: 'Tampering',
  R: 'Repudiation',
  I: 'Info Disclosure',
  D: 'Denial of Service',
  E: 'Elevation of Privilege',
};

export const STRIDE_COLORS: Record<StrideCategory, string> = {
  S: 'bg-purple-100 text-purple-700 dark:bg-purple-950 dark:text-purple-400',
  T: 'bg-red-100 text-red-700 dark:bg-red-950 dark:text-red-400',
  R: 'bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-400',
  I: 'bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-400',
  D: 'bg-orange-100 text-orange-700 dark:bg-orange-950 dark:text-orange-400',
  E: 'bg-rose-100 text-rose-700 dark:bg-rose-950 dark:text-rose-400',
};

export const STATUS_CONFIG: Record<StrideStatus, { label: string; icon: string; color: string }> = {
  open: { label: 'Open', icon: '❌', color: 'text-red-600 dark:text-red-400' },
  partial: { label: 'Partial', icon: '⚠️', color: 'text-amber-600 dark:text-amber-400' },
  mitigated: { label: 'Mitigated', icon: '✅', color: 'text-green-600 dark:text-green-400' },
  accepted: { label: 'Accepted', icon: '🔵', color: 'text-blue-600 dark:text-blue-400' },
  na: { label: 'N/A', icon: '➖', color: 'text-gray-500' },
};
